import React from "react";
import Intro from "../../sections/Intro/Intro";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

import Reviews from "../../sections/Reviews/Reviews";
import Included from "./Included";

const Consulting = () => {
  const reviews = [
    {
      text: "I have used Anika with Crystal Clear Consulting for years... her management reports like cash flow forecasts, budgets, etc. help anyone manage their businesses more effectively.",
      author: "Retail Consulting Team",
    },
    {
      text: "I reached out to Crystal Clear Consulting for help. Anika was VERY friendly and extreamly helpful and the finished product was exactly what I needed. 10/10 would…and have…recommend!",
      author: "Canyons School District",
    },
  ];
  return (
    <div className="column">
      <Header />
      <Intro
        primary="Plan for consistent wealth and growth."
        secondary="Data-driven financial insights for businesses that take their progress seriously."
      />
      <Reviews reviews={reviews} />
      <img
        className="crystals_light crystals_flipped"
        src={require("../../images/crystals_light.png")}
        alt="crystals"
      />

      <Included />

      <Footer />
    </div>
  );
};

export default Consulting;
